var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('h2',{staticClass:"page-titles"},[_vm._v("Swag Store")]),_c('OrderStats'),_c('InventoryStats'),_c('TrendingGifts'),_c('OrderChart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }